import { isMobile } from 'app-components/utils/core';
import { Guide, guidePreferenceMap } from './transactionsProcessingTypes';

import type RootState from 'app-components/utils/redux-store/rootState';
import { Dispatch } from 'redux';
import { preferencesV2Actions, preferencesV2Selectors } from '../preferences-v2';

const getClient = () => (isMobile() ? 'mobile' : 'web');

/**
 * Filters out permanently dismissed guide messages.
 */
export const guideFilter = (state: RootState) => (guide: Guide) => {
  const prefName = guidePreferenceMap[guide][getClient()];
  return preferencesV2Selectors.getPreferenceValue(state, prefName, true);
};

/**
 * Call when user clicks "do not show again" on client to disable guide
 */
export const dontShowGuideAgain = (dispatch: Dispatch, state: RootState, guide: Guide) => {
  const preferenceName = guidePreferenceMap[guide][getClient()];
  const prefObj = preferencesV2Selectors.getPreferenceObj(state, preferenceName);

  dispatch(
    preferencesV2Actions.updatePreferenceOverride({
      preferenceName,
      value: false,
      preferenceId: prefObj?.preferenceId,
      id: preferenceName,
      dataType: prefObj?.dataType,
    }),
  );
};
